import type { Term } from '@cian/frontend-e2e-deal-component';
import { ICalculatorOfferModal } from 'shared/repositories/mortgage-broker-calculator/entities/modal/CalculatorOfferModal';
import { IRow } from 'shared/repositories/mortgage-broker-calculator/entities/modal/Row';

const BANK_LOGO_BASE_URL = 'https://static.cdn-cian.ru/frontend/mortgage-assets/banks/';

export const getBankLogoUrl = (iconPath: string): string => `${BANK_LOGO_BASE_URL}${iconPath}`;

const mapRowsToTerms = (rows: IRow[]): Term[] =>
  rows.map(row => ({
    name: row.key,
    value: row.value,
    tooltip: row.tooltip ?? undefined,
  }));

export const mapCalculatorOfferModalToTermsModal = (modal: ICalculatorOfferModal, iconPath: string) => ({
  title: modal.title,
  logo: getBankLogoUrl(iconPath),
  subtitle: modal.subtitle,
  terms: mapRowsToTerms(modal.terms),
  allTerms: mapRowsToTerms(modal.rows),
  documentsText: modal.documentsText ?? undefined,
});
